'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  object-position: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledPicture = styled.picture(_templateObject());
var StyledImg = styled.img(_templateObject2(), function (_ref) {
  var imgPosition = _ref.imgPosition;
  return imgPosition;
});

var Picture = function Picture(_ref) {
  var src = _ref.src,
      srcsets = _ref.srcsets,
      alt = _ref.alt,
      title = _ref.title,
      imgPosition = _ref.imgPosition,
      className = _ref.className;
  if (!src) return null;
  return /*#__PURE__*/React.createElement(StyledPicture, {
    className: className
  }, srcsets.map(function (source) {
    return /*#__PURE__*/React.createElement("source", {
      srcSet: source.srcset,
      media: source.media,
      key: source.srcset
    });
  }), /*#__PURE__*/React.createElement(StyledImg, {
    src: src,
    alt: alt,
    title: title,
    imgPosition: imgPosition,
    className: className
  }));
};

var picturePropTypes = {
  /**
   * src attribute for the img tag
   */
  src: PropTypes.string.isRequired,

  /**
   * srcsets attribute for the picture tag
   */
  srcsets: PropTypes.arrayOf(PropTypes.shape({
    srcset: PropTypes.string,
    media: PropTypes.string
  })),

  /**
   * alt text
   */
  alt: PropTypes.string,

  /**
   * title text
   */
  title: PropTypes.string,

  /**
   * set the object-position property
   */
  imgPosition: PropTypes.oneOf(['bottom', 'center', 'inherit', 'initial', 'left', 'revert', 'right', 'top', 'unset']),

  /**
   * Classes to be applied to the Picture component
   */
  className: PropTypes.string
};
Picture.propTypes = picturePropTypes;
Picture.defaultProps = {
  srcsets: [],
  alt: '',
  title: '',
  imgPosition: 'left',
  className: ''
};

exports.Picture = Picture;
exports.picturePropTypes = picturePropTypes;
